// src/pages/JobOp.js
import React from "react";
import "./JobOp.css";
import Warning from "../assets/warning1.png";
import { Helmet } from "react-helmet";

const JobOp = () => {
  return (
    <div>
      <Helmet>
        <title>Teach With Us | Londonhouse </title>
      </Helmet>
    <div className="job-op-container">
      <h1>TEACHING AND VACANCIES</h1>
      <table className="vacancies-table">
        <thead>
          <tr>
            <th>Our Teachers</th>
            <th>Required Qualifications</th>
            <th>Benefit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>
                Our experienced teaching staff is composed of highly qualified university graduates who also have a Teaching English as a Foreign Language (TEFL) certificate. They have an aptitude for providing an environment where learning English is enjoyable. <br />
                <br />
                London House School of English, Chiang Mai, Thailand is expanding and requires EFL teachers to join our team in Chiang Mai.
              </p>
            </td>
            <td>
              <ul>
                <li>Male / Female above 21</li>
                <li>Native English Speakers (US, UK, CA, AU, NZ)</li>
                <li>Have a teaching qualification</li>
                <li>Have a Bachelor’s degree (for work permit)</li>
                <li>Experience for teaching young learners and IELTS desirable</li>
                <li>Able to handle large class size</li>
                <li>Able to attend an interview</li>
              </ul>
            </td>
            <td>
              <ul>
                <li>12 months contract and possible extension</li>
                <li>Assistant to obtain NON-Immigrant type B</li>
                <li>Applying for teaching registration, work permit and working visa</li>
                <li>BUPA health and accident Insurance</li>
                <li>Tax allowance during academy term</li>
                <li>One week paid holiday</li>
                <li>Bonus at the end of academic year (12 months)</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="warning-container">
        <div class="warning-picture">
            <img src={Warning} alt="warning" />
        </div>
        <div class="warning-word">
            <p>Interested applicants should send a detailed CV with Photo to
                <br/>rocha.trisilp@londonhouse-cm.com </p>
        </div>
    </div>
    </div>
    </div>
  );
};

export default JobOp;
